"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * [[MeetingEventsClientConfiguration]] contains necessary information to
 * report meeting events metadata to each event while sending events to the ingestion service.
 */

var MeetingEventsClientConfiguration = /*#__PURE__*/function () {
  function MeetingEventsClientConfiguration(meetingId, attendeeId, authenticationToken) {
    var eventsToIgnore = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    _classCallCheck(this, MeetingEventsClientConfiguration);

    this.type = 'Meet';
    this.v = 1;
    this.meetingId = meetingId;
    this.attendeeId = attendeeId;
    this.eventsToIgnore = eventsToIgnore;
    this.authenticationToken = authenticationToken;
  }

  _createClass(MeetingEventsClientConfiguration, [{
    key: "getAuthenticationToken",
    value: function getAuthenticationToken() {
      return this.authenticationToken;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var attributes = {};
      attributes.type = this.type;
      attributes.v = this.v;
      attributes.meetingId = this.meetingId;
      attributes.attendeeId = this.attendeeId;
      return attributes;
    }
  }]);

  return MeetingEventsClientConfiguration;
}();

exports.default = MeetingEventsClientConfiguration;